export const comments_4791866 = {"data":{"data":[],"links":{}}}